import React, { ReactElement } from "react";
import { ProjectTask, ProjectTaskComment, ProjectTaskCommentListItem } from ".";

import { Loading } from "../ui";

interface IProps {
	task: ProjectTask;
}

export const ProjectTaskCommentList = (props: IProps): ReactElement => {
	if (!props.task.comments) {
		return <Loading />;
	}

	if (!props.task.comments.length) {
		return (
			<div className="empty-message">
				<span>
					No comments available, use the form below to leave a
					comment.
				</span>
			</div>
		);
	}

	const commentEls = props.task.comments.map(
		(comment: ProjectTaskComment, index: number) => {
			return (
				<ProjectTaskCommentListItem
					comment={comment}
					task={props.task}
					key={index}
				/>
			);
		},
	);

	return <div>{commentEls}</div>;
};
